'use es6';

import { MINIMUM_FETCH_FILES_AND_FOLDERS_LIMIT } from 'FileManagerCore/Constants';
export default function getFetchedFilesAndFoldersLimit(page, pageSize, minimum = MINIMUM_FETCH_FILES_AND_FOLDERS_LIMIT) {
  const total = page * pageSize;
  const limit = Math.ceil(total / minimum) * minimum;
  return limit || minimum;
}